import React, { Fragment, useState, useEffect } from "react";
import { database } from "../../database/firebase";
import { Header } from "../../components";
import QRCode from 'qrcode.react';
//import validator from 'validator';
//import { useHistory } from "react-router-dom";

function RegisterFisher() {
  //const history = useHistory();
  //const [emailError, setEmailError] = useState('');
  // const [passwordError, setPasswordError] = useState('');
  // const [casaUid, setCasaUid] = useState("");
  const [user, setUser] = useState({});
  const [fisherUid, setFisherUid] = useState("");
  const [generate, setGenerate] = useState("false");
  const [info, setInfo] = useState({
    infodate: ""
  })

  const [newFisherAcc, setNewFisherAcc] = useState(
    {
      firstName: "",
      lastName: "",
      mobileNum: "",
      fishGear: "Bag Net",
      vesselNum: "",
      regOrigin: "",
      regDate: "",
      regExpiry: "",
      regStatus: ""
    }
  );
  useEffect(() => {


    let uid = localStorage.getItem("uid");
    if (uid) {
      let userUid = JSON.parse(uid);
      database.child(`users/${userUid}`).once("value", (snap) => {
        let data = snap.val();
        setUser(data);

      });
    };

  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewFisherAcc((prevState) => ({
      ...prevState,
      [name]: value
    }));

  }


  // const handleEmail = (e) => {

  //   const { name, value } = e.target;

  //   if (validator.isEmail(value)) {
  //     setEmailError('Valid Email!')
  //     setNewFisherAcc((prevState) => ({
  //       ...prevState,
  //       [name]: value
  //     }));
  //   } else {
  //     setEmailError('Enter valid Email!')
  //   }
  // }

  // const handlePassword = (e) => {

  //   const { name, value } = e.target;


  //   if (value.length > 7) {
  //     setPasswordError('Valid Password!');
  //     setNewFisherAcc((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //       casaEmail: user.email,
  //       casaPw: user.password
  //     }));

  //   } else {
  //     setPasswordError('Enter at least 8 characters.')
  //   }

  // }

  const handleRegDate = (e) => {
    const { value } = e.target;

    let date = new Date(value);
    let xdd = date.getDate();
    let xmm = date.getMonth() + 1;
    let xyy = date.getFullYear() + 1;
    let xdate = new Date(xyy + "-" + xmm + "-" + xdd);
    let todate = Date.now();

    setInfo((prevState) => ({
      ...prevState,
      infodate: value
    }));

    if (todate > xdate.getTime()) {
      setNewFisherAcc((prevState) => ({
        ...prevState,
        regDate: date.getTime(),
        regExpiry: xdate.getTime(),
        regStatus: "expired"
      }));
    }
    else {
      setNewFisherAcc((prevState) => ({
        ...prevState,
        regDate: date.getTime(),
        regExpiry: xdate.getTime(),
        regStatus: "active"
      }));
    }
  }

  const {
    //casaEmail,
    //casaPw,
    mobileNum,
    firstName,
    lastName,
    vesselNum,
    regOrigin,
    fishGear,
    regDate,
    regExpiry,
    regStatus
  } = newFisherAcc;

  const {
    infodate
  } = info;

  const downloadQR = () => {

    const canvas = document.getElementById("fisherQR");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/octet-stream", "image/png");

    database
      .child(`users/${user.uid}/userfisher/${fisherUid}/`)
      .update({
        fisherQR: pngUrl,
        fisherUid: fisherUid
      })
      .then(() => {
        alert("User signed up successfully.");
      });

    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = lastName + '_' + firstName + '.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  const handleSubmit = () => {

    if (!mobileNum || !firstName ||
      !lastName || !vesselNum || !regOrigin || !fishGear) {
      alert("All fields are required.");
    } else {

      var newUser = {
        casaUid: user.uid,
        firstName,
        fishGear,
        lastName,
        mobileNum,
        regOrigin,
        vesselNum,
        regDate,
        regExpiry,
        regStatus,
      };

      var newFisherUser =
        database
          .child(`users/${user.uid}/userfisher`)
          .push(newUser);

      var newFisherUserId =
        newFisherUser.key;

      setFisherUid(newFisherUserId);
      setGenerate(true);
    }
  };


  return (
    <div className="md:flex">
      <aside class="md:h-screen md:sticky md:top-0">
        <Header />
      </aside>
      <Fragment>
        <div className="min-h-screen w-full bg-gray-100 py-6 flex flex-col items-center justify-center sm:py-12 z-0">
          <div className="max-w-screen-lg mx-auto px-5 py-10 rounded-3xl bg-white shadow-lg sm:p-10">
            <div>
              <div className="text-left space-y-2 sm:text-left">
                <div>
                  <p className="text-2xl pb-5 text-blue-900 font-sans font-bold">
                    Step 1: Input fisherman details.
                  </p>
                </div>

              </div>
              <div className="sm:flex mb-4">
                <div className="px-5">
                  <p> First Name</p>
                  <input
                    type="text"
                    placeholder="Fisherman First Name"
                    name="firstName"
                    onChange={handleChange}
                    value={firstName}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                  <p> Last Name</p>
                  <input
                    type="text"
                    placeholder="Fisherman Last Name"
                    name="lastName"
                    onChange={handleChange}
                    value={lastName}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                  <p> Vessel Registration Number</p>
                  <input
                    type="text"
                    placeholder="Vessel Registration No."
                    name="vesselNum"
                    onChange={handleChange}
                    value={vesselNum}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                  <p> Origin of Registration</p>
                  <input
                    type="text"
                    placeholder="Origin of Registration"
                    name="regOrigin"
                    onChange={handleChange}
                    value={regOrigin}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                  <p> Date of Registration</p>
                  <input
                    type="date"
                    name="regDate"
                    onChange={handleRegDate}
                    value={infodate}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />

                </div>
                <div className="px-5">
                  <p className="mb-3"> Type of Fishing Gear</p>
                  <select id="fishGear" name="fishGear" onChange={handleChange}
                    className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 mb-4 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-gray-100 focus:ring-indigo-500"
                  >
                    <option value="Bag Net" className="text-sm font-medium text-gray-700"> Bag Nets </option>
                    <option value="Beach Seine" className="text-sm font-medium text-gray-700"> Beach Seine</option>
                    <option value="Cast Nets" className="text-sm font-medium text-gray-700"> Cast Nets </option>
                    <option value="Fish Corral" className="text-sm font-medium text-gray-700"> Fish Corral </option>
                    <option value="Gill Nets" className="text-sm font-medium text-gray-700"> Gill Nets </option>
                    <option value="Handline" className="text-sm font-medium text-gray-700"> Handline </option>
                    <option value="Hook and Line" className="text-sm font-medium text-gray-700"> Hook and Line </option>
                    <option value="Long Line" className="text-sm font-medium text-gray-700"> Long Line </option>
                    <option value="Traps/Pots " className="text-sm font-medium text-gray-700"> Traps/Pots </option>
                    <option value="Beach Seine" className="text-sm font-medium text-gray-700"> Beach Seine</option>
                    <option value="Purse Seines" className="text-sm font-medium text-gray-700"> Purse Seine </option>
                    <option value="Ring Net" className="text-sm font-medium text-gray-700"> Ring Net </option>
                  </select>



                  <p>Mobile Number</p>
                  <input
                    type="number"
                    placeholder="09XXXXXXXXX"
                    name="mobileNum"
                    onChange={handleChange}
                    value={mobileNum}
                    className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />

                  <div className="text-center">
                    <button
                      onClick={handleSubmit}
                      type="submit"
                      className="my-4 w-full bg-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200">
                      Register</button>
                  </div>
                </div>
                <div className="p-5 bg-gray-100 rounded-3xl">
                  <div>

                    {generate === true ? (
                      <>
                        <div>
                          <p className="text-2xl pb-5 text-blue-900 font-sans font-bold">
                            Step 2: Register QR Code.
                          </p>
                        </div>
                        <QRCode
                          id='fisherQR'
                          value={JSON.stringify({
                            mobileNum: mobileNum,
                            firstName: firstName,
                            lastName: lastName,
                            vesselNum: vesselNum,
                            regOrigin: regOrigin,
                            fishGear: fishGear,
                            casaEmail: user.email,
                            casaPw: user.password,
                            casaUid: user.uid,
                            fisherUid: fisherUid,
                          })}
                          size={290}
                          level={"L"}
                          includeMargin={true}
                          fgColor={"#1e3a8a"}
                        />
                        <div>
                          <button
                            onClick={downloadQR}
                            type="submit"
                            className="my-4 w-full bg-blue-600 text-white text-base font-regular py-2 px-4 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200">
                            Register QR Code
                          </button>
                        </div>
                      </>)
                      :
                      <div />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  );
}


export default RegisterFisher;